import { installProcessEnvShim } from './processEnvShim';

installProcessEnvShim();

// https://webpack.js.org/concepts/module-federation/#uncaught-error-shared-module-is-not-available-for-eager-consumption
import('./main.ts');
